import types from './mutationTypes';

export default {
  [types.SET_KEYCLOAK](state, keycloak) {
    state.keycloak = keycloak;
  },
};
